import { render } from "./AddSongModal.vue?vue&type=template&id=2d1c855a&scoped=true"
import script from "./AddSongModal.vue?vue&type=script&lang=js"
export * from "./AddSongModal.vue?vue&type=script&lang=js"

import "./AddSongModal.vue?vue&type=style&index=0&id=2d1c855a&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1c855a"]])

export default __exports__